import { dispatch } from "@rematch/core";

import {
  activitiesService,
  communitiesService,
  activitiesDndService,
  communitiesDndService,
  activitiesImportService,
  practicesService,
  publishedContentsService,
  activityActionsService
} from "../../services/feathers.service";
import { toastr } from "react-redux-toastr";

const initialState = {
  createPackError: null,
  selectedPracticeFlowActivity: {},
  parentPhase: "",
  selectedPracticeFlowCommunity: {},
  communityActions: [],
  activityAction: [],
  parentCommunity: "",
  publishedContent: [],
  isContentModalOpen: false,
  isAddActivityModalOpen: false,
  isPhaseAddFlag: false,
  activityUniqueId: null,
  validationCheck: false,
  activityBeforeEdit: {},
  // resourcepaneDefaultOpenTab: null,
  duplicateIconFlag: false,
  selectedDataItem: {},
  activityActions: {},
};

export default {
  state: initialState,
  reducers: {
    setErrorData(state, payload) {
      return {
        ...state,
        createPackError: payload,
      };
    },
    setSelectedDataItem(state, payload) {
      return {
        ...state,
        selectedDataItem: payload,
      };
    },
    setSelectedActivityData(state, payload = {}) {
      return {
        ...state,
        selectedPracticeFlowActivity: payload,
      };
    },
    setSelectedActivityActions(state, payload = {}) {
      return {
        ...state,
        activityActions: payload,
      };
    },
    setSelectedActivityBeforeEditData(state, payload = {}) {
      return {
        ...state,
        activityBeforeEdit: payload,
      };
    },
    setParentPhaseNameOnSelection(state, payload = "") {
      return {
        ...state,
        parentPhase: payload,
      };
    },
    setParentCommunityNameOnSelection(state, payload = "") {
      return {
        ...state,
        parentCommunity: payload,
      };
    },
    setRaciObjectOfselectedActivity(state, payload = {}) {
      return {
        ...state,
        selectedPracticeFlowActivity: {
          ...state.selectedPracticeFlowActivity,
          raci: payload,
        },
      };
    },
    setRaciObjectOfselectedCommunity(state, payload = {}) {
      return {
        ...state,
        selectedPracticeFlowCommunity: {
          ...state.selectedPracticeFlowCommunity,
          raci: payload,
        },
      };
    },
    addDependencyToSelectedActivity(state, payload) {
      return {
        ...state,
        selectedPracticeFlowActivity: {
          ...state.selectedPracticeFlowActivity,
          dependencies: [
            ...state.selectedPracticeFlowActivity.dependencies,
            payload,
          ],
        },
      };
    },
    removeDependencyFromActivity(state, payload) {
      return {
        ...state,
        selectedPracticeFlowActivity: {
          ...state.selectedPracticeFlowActivity,
          dependencies: [
            ...state.selectedPracticeFlowActivity.dependencies.slice(
              0,
              payload
            ),
            ...state.selectedPracticeFlowActivity.dependencies.slice(
              payload + 1
            ),
          ],
        },
      };
    },
    setSelectedCommunityData(state, payload = {}) {
      return {
        ...state,
        selectedPracticeFlowCommunity: payload,
      };
    },
    addCommunityAction(state, payload = {}) {
      return {
        ...state,
        communityActions: [...state.communityActions, payload],
      };
    },
    clearCommunityActions(state) {
      return {
        ...state,
        communityActions: [],
      };
    },
    addActivityAction(state, payload = {}) {
      return {
        ...state,
        activityAction: [...state.activityAction, payload],
      };
    },
    clearActivityActions(state) {
      return {
        ...state,
        activityAction: [],
      };
    },

    deleteRReferenceFromCommunity(state, payload) {
      return {
        ...state,
        selectedPracticeFlowCommunity: {
          ...state.selectedPracticeFlowCommunity,
          raci: {
            ...state.selectedPracticeFlowCommunity.raci,
            r: [
              ...state.selectedPracticeFlowCommunity.raci.r.slice(0, payload),
              ...state.selectedPracticeFlowCommunity.raci.r.slice(payload + 1),
            ],
          },
        },
      };
    },
    deleteAReferenceFromCommunity(state, payload) {
      return {
        ...state,
        selectedPracticeFlowCommunity: {
          ...state.selectedPracticeFlowCommunity,
          raci: {
            ...state.selectedPracticeFlowCommunity.raci,
            a: [
              ...state.selectedPracticeFlowCommunity.raci.a.slice(0, payload),
              ...state.selectedPracticeFlowCommunity.raci.a.slice(payload + 1),
            ],
          },
        },
      };
    },
    deleteCReferenceFromCommunity(state, payload) {
      return {
        ...state,
        selectedPracticeFlowCommunity: {
          ...state.selectedPracticeFlowCommunity,
          raci: {
            ...state.selectedPracticeFlowCommunity.raci,
            c: [
              ...state.selectedPracticeFlowCommunity.raci.c.slice(0, payload),
              ...state.selectedPracticeFlowCommunity.raci.c.slice(payload + 1),
            ],
          },
        },
      };
    },
    deleteIReferenceFromCommunity(state, payload) {
      return {
        ...state,
        selectedPracticeFlowCommunity: {
          ...state.selectedPracticeFlowCommunity,
          raci: {
            ...state.selectedPracticeFlowCommunity.raci,
            i: [
              ...state.selectedPracticeFlowCommunity.raci.i.slice(0, payload),
              ...state.selectedPracticeFlowCommunity.raci.i.slice(payload + 1),
            ],
          },
        },
      };
    },
    removeItemFromCommunityAction(state, payload) {
      return {
        ...state,
        communityActions: [
          ...state.communityActions.slice(0, payload),
          ...state.communityActions.slice(payload + 1),
        ],
      };
    },
    removeItemFromActivityAction(state, payload) {
      return {
        ...state,
        activityAction: [
          ...state.activityAction.slice(0, payload),
          ...state.activityAction.slice(payload + 1),
        ],
      };
    },

    addInputs(state, payload) {
      return {
        ...state,
        selectedPracticeFlowActivity: {
          ...state.selectedPracticeFlowActivity,
          inputs: [...state.selectedPracticeFlowActivity.inputs, payload],
        },
      };
    },
    removeInputs(state, payload) {
      return {
        ...state,
        selectedPracticeFlowActivity: {
          ...state.selectedPracticeFlowActivity,
          inputs: [
            ...state.selectedPracticeFlowActivity.inputs.slice(0, payload),
            ...state.selectedPracticeFlowActivity.inputs.slice(payload + 1),
          ],
        },
      };
    },

    addOutputs(state, payload) {
      return {
        ...state,
        selectedPracticeFlowActivity: {
          ...state.selectedPracticeFlowActivity,
          outputs: [...state.selectedPracticeFlowActivity.outputs, payload],
        },
      };
    },
    removeOutputs(state, payload) {
      return {
        ...state,
        selectedPracticeFlowActivity: {
          ...state.selectedPracticeFlowActivity,
          outputs: [
            ...state.selectedPracticeFlowActivity.outputs.slice(0, payload),
            ...state.selectedPracticeFlowActivity.outputs.slice(payload + 1),
          ],
        },
      };
    },

    setContentListData(state, payload = []) {
      return {
        ...state,
        publishedContent: payload,
      };
    },
    setContentModalOpen(state, payload) {
      return {
        ...state,
        isContentModalOpen: payload,
      };
    },
    setAddActivityModalOpen(state, payload) {
      return {
        ...state,
        isAddActivityModalOpen: payload,
      };
    },
    setPhaseModalOpen(state, payload) {
      return {
        ...state,
        isPhaseAddFlag: payload,
      };
    },
    setreferenceContentData(state, payload) {
      return {
        ...state,
        selectedPracticeFlowActivity: {
          ...state.selectedPracticeFlowActivity,
          references: [
            ...state.selectedPracticeFlowActivity.references,
            ...payload,
          ],
        },
      };
    },

    removeReferences(state, payload) {
      return {
        ...state,
        selectedPracticeFlowActivity: {
          ...state.selectedPracticeFlowActivity,
          references: [
            ...state.selectedPracticeFlowActivity.references.slice(0, payload),
            ...state.selectedPracticeFlowActivity.references.slice(payload + 1),
          ],
        },
      };
    },
    setActivityUniqueId(state, payload) {
      return {
        ...state,
        activityUniqueId: payload,
      };
    },

    setValidationCheck(state, payload) {
      return {
        ...state,
        validationCheck: payload,
      };
    },

    clearDataForSelectedActivity(state) {
      return {
        ...state,
        selectedPracticeFlowActivity: {},
        activityUniqueId: null,
      };
    },
    setDuplicateIcon(state, payload) {
      return {
        ...state,
        duplicateIconFlag: payload,
      };
    },
    clear() {
      return initialState;
    },
  },
  effects: {
    async getSelectedActivityAsync(payload, state) {
      dispatch.createPack.setError(null);
      const activityData = await activitiesService.get(payload, {
        query: {
          isPublic:
            state.lifeCycle.selectedPracticeLibrary.scope === "Public"
              ? true
              : false,
          $populate: [
            {
              path: "notes.accountUserId",
              populate: "accountUserId",
              select: "_id firstName lastName profilePic email ",
            },
            {
              path: "smartIntegration",
              populate: "smartIntegration",
              select: "_id label version image ",
            },
            {
              path: "attachments.uploadedBy",
              populate: "uploadedBy",
              select: "_id firstName lastName profilePic ",
            },
            {
              path: "references.id",
              populate: "contentData",
              select: "_id name scope contentpath createdBy type deleted",
              populate: [
                {
                  path: "createdBy",
                  populate: "createdBy",
                  select: "_id firstName lastName profilePic ",
                },
              ],
            },
            {
              path: "parentActivity",
              populate: "parentActivity",
              select:
                "_id name references parentActivity isLeafNode isParentNode",
              populate: [
                {
                  path: "references.id",
                  populate: "contentData",
                  select: "_id name scope contentpath type deleted",
                  populate: [
                    {
                      path: "createdBy",
                      populate: "createdBy",
                      select: "_id firstName lastName profilePic ",
                    },
                  ],
                },
                {
                  path: "parentActivity",
                  populate: "parentActivity",
                  select: "_id name references isLeafNode isParentNode",
                  populate: [
                    {
                      path: "references.id",
                      populate: "contentData",
                      select: "_id name scope contentpath type deleted",
                      populate: [
                        {
                          path: "createdBy",
                          populate: "createdBy",
                          select: "_id firstName lastName profilePic ",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      });
      dispatch.createPack.setSelectedActivity(activityData);
      dispatch.createPack.setSelectedActivityBeforeEditData(activityData.raci);
      dispatch.createPack.clearActivityActions();
      dispatch.createPack.clearCommunityActions();
      dispatch.createPack.setSelectedCommunity({});
      await this.getSelectedActivityActions(payload);
      return true;
    },
    async getSelectedActivityActions(payload, state) {
      let activityActions = await activityActionsService.find({
        query: {
          "activityId": payload,
          $populate: [{
              path: "createdBy",
              populate: "createdBy",
              select: "_id firstName lastName profilePic email ",
            }
          ]
        }
      });
      dispatch.createPack.setSelectedActivityActions(activityActions);
      return activityActions;
    },
    setError(payload) {
      dispatch.createPack.setErrorData(payload);
    },
    setSelectedActivity(payload) {
      dispatch.createPack.setSelectedActivityData(payload);
    },
    setParentPhaseName(payload) {
      dispatch.createPack.setParentPhaseNameOnSelection(payload);
    },
    setParentCommunityName(payload) {
      dispatch.createPack.setParentCommunityNameOnSelection(payload);
    },
    setRACIObject(payload) {
      dispatch.createPack.setRaciObjectOfselectedActivity(payload);
    },
    addDependency(payload) {
      dispatch.createPack.addDependencyToSelectedActivity(payload);
    },
    removeDependency(payload) {
      dispatch.createPack.removeDependencyFromActivity(payload);
    },
    async getSelectedCommunityAsync(payload, state) {
      try {
        dispatch.createPack.setError(null);

        const communityData = await communitiesService.get(payload, {
          query: {
            isPublic:
              state.lifeCycle.selectedPracticeLibrary.scope === "Public"
                ? true
                : false,
          },
        });

        dispatch.createPack.setSelectedCommunity(communityData);
        dispatch.createPack.clearActivityActions();
        dispatch.createPack.clearCommunityActions();
        dispatch.createPack.setSelectedActivity({});
        await this.getSelectedActivityActions(payload);
        return true;
      } catch (error) {
        throw error;
      }
    },
    setSelectedCommunity(payload) {
      dispatch.createPack.setSelectedCommunityData(payload);
    },
    async editActivityAsync(payload, state) {
      let editActivity = payload;
        editActivity.activityAction = state.createPack.activityAction;
      try {
        dispatch.createPack.updateActivityInPlaybook(editActivity);
        let updateOldActivity = await activitiesService.patch(
          editActivity._id,
          editActivity,
          {
            query: {
              $populate: [
                {
                  path: "references.id",
                  populate: "contentData",
                  select: "_id name scope contentpath type",
                },
              ],
            },
          }
        );
        dispatch.lifeCycle.updateSelectedPracticeLibrary({
          id: updateOldActivity._id,
          element: "activities",
          data: updateOldActivity,
        });
        if (editActivity.applyChangesOnChildren) {
          toastr.success("Message", "RACI propagated successfully");
        }
      } catch (err) {
        dispatch.createPack.setError(err);
        toastr.error("Message", "Failed to update ");
        throw err;
      }
    },

    async editCommunityAsync(payload, state) {
      let editCommunity = payload;
      editCommunity.communityActions = state.createPack.communityActions;
      try {
        dispatch.createPack.updateCommunityInPlaybook(editCommunity);
        await communitiesService.patch(editCommunity._id, editCommunity);
      } catch (err) {
        dispatch.createPack.setError(err);
        toastr.error("Message", "Failed to update ");
        throw err;
      }
    },
    setRACIObjectOnCommunity(payload) {
      dispatch.createPack.setRaciObjectOfselectedCommunity(payload);
    },
    updateCommunityAction(payload) {
      dispatch.createPack.addCommunityAction(payload);
    },
    updateActivityAction(payload) {
      dispatch.createPack.addActivityAction(payload);
    },

    deleteRFromCommunity(payload) {
      dispatch.createPack.deleteRReferenceFromCommunity(payload);
    },
    deleteAFromCommunity(payload) {
      dispatch.createPack.deleteAReferenceFromCommunity(payload);
    },
    deleteCFromCommunity(payload) {
      dispatch.createPack.deleteCReferenceFromCommunity(payload);
    },
    deleteIFromCommunity(payload) {
      dispatch.createPack.deleteIReferenceFromCommunity(payload);
    },
    removeFromCommunityAction(payload) {
      dispatch.createPack.removeItemFromCommunityAction(payload);
    },
    removeFromActivityAction(payload) {
      dispatch.createPack.removeItemFromActivityAction(payload);
    },

    addInput(payload) {
      dispatch.createPack.addInputs(payload);
    },
    removeInput(payload) {
      dispatch.createPack.removeInputs(payload);
    },

    addOutput(payload) {
      dispatch.createPack.addOutputs(payload);
    },
    removeOutput(payload) {
      dispatch.createPack.removeOutputs(payload);
    },
    // is called on playbook sequence page
    async getPublishedContentDataAsync(payload) {
      try {
        dispatch.createPack.setError(null);

        let query = {
          $and: [
            {
              _id: {
                $nin: payload.referencesIdsArr,
              },
            },
          ],
          scope: payload.scope,
          $limit: payload.limit ? payload.limit : 10,
        };

        if (payload.baseCategory && payload.baseCategory._id) {
          query.baseCategory = payload.baseCategory._id;
        }
        if (payload.category && payload.category._id) {
          query.category = payload.category._id;
        }

        if (payload.scope) {
          query.scope = payload.scope;
        }
        if (payload.name) {
          payload.name = payload.name.replace("*", "\\*");
          payload.name = payload.name.replace("(", "\\(");
          payload.name = payload.name.replace(")", "\\)");
          payload.name = payload.name.replace("+", "\\+");
          payload.name = payload.name.replace("?", "\\?");
          payload.name = payload.name.replace("[", "\\[");
          payload.name = payload.name.replace("]", "\\]");
          query.$and.push({ name: { $regex: payload.name, $options: "i" } });
        }

        if (payload.subCategoryArr && payload.subCategory === "Others") {
          query.subCategory = {
            $nin: payload.subCategoryArr,
          };
        } else if (payload.subCategory && payload.subCategory._id) {
          query.subCategory = payload.subCategory._id;
        }

        query.deleted = { $exists: false };
        const contentData = await publishedContentsService.find({
          query: query,
        });
        dispatch.createPack.setContentList(contentData);
      } catch (err) {
        dispatch.createPack.setError(err);
        toastr.error("Message", "fail to get");
        throw err;
      }
    },
    setContentList(payload) {
      dispatch.createPack.setContentListData(payload);
    },

    contentModalOpen(onOffState) {
      dispatch.createPack.setContentModalOpen(onOffState);
    },
    addActivityModalOpen(onOffState) {
      dispatch.createPack.setAddActivityModalOpen(onOffState);
    },
    PhaseModalOpen(onOffState) {
      dispatch.createPack.setPhaseModalOpen(onOffState);
    },

    setreferenceContentDataAsync(payload) {
      dispatch.createPack.setreferenceContentData(payload);
    },

    removeReference(payload) {
      dispatch.createPack.removeReferences(payload);
    },
    async changeActivityIndex(payload, state) {
      await activitiesDndService.create(payload);
    },
    async createCopyAndPushToActivity(payload) {
      try {
        await activitiesImportService.create(payload);
        dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(
          payload.selectedPracticeLibrary
        );
      } catch (err) {
        throw err;
      }
    },
    async changeCommunityIndex(payload) {
      await communitiesDndService.create(payload);
    },
    activityUniqueIdSet(payload) {
      dispatch.createPack.setActivityUniqueId(payload);
    },
    setValidationCheckFlag(payload) {
      dispatch.createPack.setValidationCheck(payload);
    },
    async importPractice(payload) {
      return await practicesService.create(payload);
    },
    updateActivityInPlaybook(payload, state) {
      delete payload.activities;
      let pack = state.lifeCycle.selectedPracticeLibrary;
      if(pack && pack._id && pack._id.toString() === payload.packId.toString()){
        if(pack.sequenceViewMap && pack.sequenceViewMap.get(payload._id)){
          pack.sequenceViewMap.set(payload._id,
            Object.assign(pack.sequenceViewMap.get(payload._id), payload, {duration: payload.duration, name: payload.name})
          );
        }
        if(pack.communities){
          let communityUpdate = {};
          for(let i = 0; i < pack.communities.length; i++){
            if(pack.communities[i].communities){
              for(let j = 0; j < pack.communities[i].communities.length; j++){
                if(pack.communities[i].communities[j].activities){
                  for(let k = 0; k < pack.communities[i].communities[j].activities.length; k++){
                    if(pack.communities[i] && pack.communities[i].communities[j] && pack.communities[i].communities[j].activities[k] && pack.communities[i].communities[j].activities[k]._id && pack.communities[i].communities[j].activities[k]._id.toString() === payload._id.toString()){
                      if(payload.isSocket && communityUpdate !== {}){
                        communityUpdate.activityToAdd = Object.assign(pack.communities[i].communities[j].activities[k], payload);
                      }
                    }
                  }
                }
              }
            }
          }
        }
        if(state.createPack.selectedPracticeFlowActivity &&
           state.createPack.selectedPracticeFlowActivity._id &&
           state.createPack.selectedPracticeFlowActivity._id.toString() === payload._id.toString()){
          dispatch.createPack.getSelectedActivityAsync(payload._id);
        }
      }
    },
    updateInSummaryDataInSummaryView(payload, state) {
      let activitySummary = Object.assign({}, state.lifeCycle.activitySummary);

      let ref = activitySummary.references;
      if (ref && ref.length !== 0) {
        for (let i = 0; i < ref.length; i++) {
          if (ref[i]._id.toString() === payload._id.toString()) {
            const result = ref[i].references.filter(({ _id: id1 }) =>
              payload.references.some(({ _id: id2 }) => id2 === id1)
            );
            activitySummary.references[i].references = result;
          }
        }
      }
      dispatch.lifeCycle.setActivitySummary(activitySummary);
    },
    updateSingleContent(payload, state) {
      let activitySummary = Object.assign({}, state.lifeCycle.activitySummary);

      let totalRef = 0;
      let totalPrivateRef = 0;
      let totalPublicRef = 0;

      if (activitySummary.references) {
        for (let i = 0; i < activitySummary.references.length; i++) {
          totalRef = activitySummary.references[i].references.length + totalRef;
          totalPrivateRef =
            activitySummary.references[i].references.filter(
              (f, i) => f.id.scope === "Private"
            ).length + totalPrivateRef;
          totalPublicRef =
            activitySummary.references[i].references.filter(
              (f, i) => f.id.scope === "Public"
            ).length + totalPublicRef;
        }
      }
      if (!activitySummary.counts) {
        activitySummary.counts = {};
      }
      activitySummary.counts.totalRef = totalRef;
      activitySummary.counts.totalPrivateRef = totalPrivateRef;
      activitySummary.counts.totalPublicRef = totalRef - totalPrivateRef;
    },
    updateCommunityInPlaybook(payload, state) {
      delete payload.communities;
      let activities = [];
      let pack = Object.assign({}, state.lifeCycle.selectedPracticeLibrary);
      if (pack.communities) {
        for (let i = 0; i < pack.communities.length; i++) {
          if (
            pack.communities[i] &&
            pack.communities[i]._id.toString() === payload._id.toString()
          ) {
            pack.communities[i] = Object.assign(pack.communities[i], payload);
          }
          for (let j = 0; j < pack.communities[i].communities.length; j++) {
            if (
              pack.communities[i].communities[j] &&
              pack.communities[i].communities[j]._id &&
              pack.communities[i].communities[j]._id.toString() ===
                payload._id.toString()
            ) {
              pack.communities[i].communities[j].activities = [];
              if (payload.raci && payload.raci.r) {
                for (let activity of payload.raci.r) {
                  let activityObject = Object.assign(
                    {},
                    state.lifeCycle.selectedPracticeLibrary.sequenceViewMap.get(
                      activity
                    )
                  );
                  activityObject.laneId =
                    pack.communities[i].communities[j]._id;
                  activityObject.boardId =
                    pack.communities[i]._id;
                  activities.push(activityObject);
                }
              }
              payload.activities = activities;
              pack.communities[i].communities[j] = Object.assign(
                pack.communities[i].communities[j],
                payload
              );
              break;
            }
          }
          if (
            state.lifeCycle.eventBus &&
            state.lifeCycle.eventBus[pack.communities[i]._id]
          ){}
            // state.lifeCycle.eventBus[pack.communities[i]._id].publish({
            //   type: "UPDATE_LANES",
            //   lanes: pack.communities[i].communities,
            // });
        }
      }
      if (
        state.createPack.selectedPracticeFlowCommunity &&
        state.createPack.selectedPracticeFlowCommunity._id &&
        state.createPack.selectedPracticeFlowCommunity._id.toString() ===
          payload._id.toString()
      ) {
        state.createPack.selectedPracticeFlowCommunity.raci = payload.raci;
      }
      dispatch.lifeCycle.setSelectedPracticeLibraryData(
        Object.assign({}, pack)
      );
    },
    showDuplicateIcon(payload) {
      dispatch.createPack.setDuplicateIcon(payload);
    },
    changeActivityPosition(payload, state) {
      const getColor = (id, communities) => {
        if (!id) return "#fff";
        for (let community of communities) {
          if (community._id.toString() === id.toString()) {
            return community.tagColor;
          }
          for (let subcommunity of community.communities) {
            if (subcommunity._id.toString() === id.toString()) {
              return subcommunity.tagColor;
            }
          }
        }
      };
      let practice = Object.assign({}, state.lifeCycle.selectedPracticeLibrary);
      if (
        state.app.user._id.toString() !== payload.userId.toString() &&
        state.app.currentContext === "designer" &&
        practice &&
        practice._id &&
        payload.node &&
        practice._id.toString() === payload.node.packId.toString()
      ) {
        if (payload.from !== "root" && payload.to !== "root") {
          if (practice.activities) {
            let fromIndex = [],
              toIndex = [];
            for (let i = 0; i < practice.activities.length; i++) {
              if (payload.from === practice.activities[i]._id) {
                fromIndex.push(i);
              }

              if (practice.activities[i].activities) {
                for (
                  let j = 0;
                  j < practice.activities[i].activities.length;
                  j++
                ) {
                  if (
                    payload.from === practice.activities[i].activities[j]._id
                  ) {
                    fromIndex.push(i, j);
                  }
                }
              }
            }
            if (fromIndex.length > 0) {
              payload.node.title = payload.node.name;
              let a = payload.node && payload.node.raci && payload.node.raci.a;
              payload.node.communityTagColor = getColor(
                a,
                practice.communities
              );
              if (fromIndex.length === 1) {
                let fromSpliceIndex;
                practice.activities[fromIndex[0]].activities.forEach(
                  (activity, index) => {
                    if (
                      activity._id.toString() === payload.node._id.toString()
                    ) {
                      fromSpliceIndex = index;
                    }
                  }
                );
                practice.activities[fromIndex[0]].activities.splice(
                  fromSpliceIndex,
                  1
                );
              } else {
                let fromSpliceIndex;
                practice.activities[fromIndex[0]].activities[
                  fromIndex[1]
                ].activities.forEach((activity, index) => {
                  if (activity._id.toString() === payload.node._id.toString()) {
                    fromSpliceIndex = index;
                  }
                });
                practice.activities[fromIndex[0]].activities[
                  fromIndex[1]
                ].activities.splice(fromSpliceIndex, 1);
              }
              let newFromLanes = [],
                fromLeafNodes = [];
              practice.activities[fromIndex[0]].activities &&
                practice.activities[fromIndex[0]].activities.forEach(
                  (activity) => {
                    if (activity.isLeafNode) {
                      fromLeafNodes.push(activity);
                    } else {
                      newFromLanes.push(activity);
                    }
                  }
                );
              let setColor;
              if (
                practice.activities[fromIndex[0]].raci &&
                practice.activities[fromIndex[0]].raci.a
              ) {
                setColor = getColor(
                  practice.activities[fromIndex[0]].raci.a,
                  practice.communities
                );
              }
              if (fromLeafNodes.length > 0) {
                let lane = {
                  _id: practice.activities[fromIndex[0]]._id,
                  title: "Others",
                  cards: fromLeafNodes,
                  label: fromLeafNodes.length,
                  communityTagColor: setColor,
                  isDummy: true,
                };
                newFromLanes.push(lane);
              } else if (newFromLanes.length === 0) {
                let lane = {
                  _id: practice.activities[fromIndex[0]]._id,
                  title: "Others",
                  cards: [],
                  label: 0,
                  communityTagColor: setColor,
                  isDummy: true,
                };
                newFromLanes.push(lane);
              }
              state.lifeCycle.eventBus[
                practice.activities[fromIndex[0]]._id
              ].publish({ type: "UPDATE_LANES", lanes: newFromLanes });
              for (let i = 0; i < practice.activities.length; i++) {
                if (payload.to === practice.activities[i]._id) {
                  toIndex.push(i);
                }
                if (practice.activities[i].activities) {
                  for (
                    let j = 0;
                    j < practice.activities[i].activities.length;
                    j++
                  ) {
                    if (
                      payload.to === practice.activities[i].activities[j]._id
                    ) {
                      toIndex.push(i, j);
                    }
                  }
                }
              }

              if (toIndex.length === 1) {
                practice.activities[toIndex[0]].activities.splice(
                  payload.index,
                  0,
                  payload.node
                );
              } else {
                if (
                  practice.activities &&
                  practice.activities[toIndex[0]].activities &&
                  practice.activities[toIndex[0]].activities[toIndex[1]]
                    .activities
                ) {
                  practice.activities[toIndex[0]].activities[
                    toIndex[1]
                  ].activities.splice(payload.index, 0, payload.node);
                  practice.activities[toIndex[0]].activities[toIndex[1]].cards =
                    practice.activities[toIndex[0]].activities[
                      toIndex[1]
                    ].activities;
                }
              }

              let newToLanes = [],
                toLeafNodes = [];
              practice.activities[toIndex[0]].activities &&
                practice.activities[toIndex[0]].activities.forEach(
                  (activity) => {
                    if (activity.isLeafNode) {
                      toLeafNodes.push(activity);
                    } else {
                      newToLanes.push(activity);
                    }
                  }
                );
              if (
                practice.activities[toIndex[0]].raci &&
                practice.activities[toIndex[0]].raci.a
              ) {
                setColor = getColor(
                  practice.activities[toIndex[0]].raci.a,
                  practice.communities
                );
              }
              if (toLeafNodes.length > 0) {
                let lane = {
                  _id: practice.activities[toIndex[0]]._id,
                  title: "Others",
                  cards: toLeafNodes,
                  label: toLeafNodes.length,
                  communityTagColor: setColor,
                  isDummy: true,
                };
                newToLanes.push(lane);
              } else if (newToLanes.length === 0) {
                let lane = {
                  _id: practice.activities[toIndex[0]]._id,
                  title: "Others",
                  cards: [],
                  label: 0,
                  communityTagColor: setColor,
                  isDummy: true,
                };
                newToLanes.push(lane);
              }
              state.lifeCycle.eventBus[
                practice.activities[toIndex[0]]._id
              ].publish({
                type: "UPDATE_LANES",
                lanes: Object.assign([], newToLanes),
              });
            }
          }
        }
      }
    },
    removeActivityFromPlaybook(payload, state) {
      const getColor = (id, communities) => {
        if (!id) return "#fff";
        for (let community of communities) {
          if (community._id.toString() === id.toString()) {
            return community.tagColor;
          }
          for (let subcommunity of community.communities) {
            if (subcommunity._id.toString() === id.toString()) {
              return subcommunity.tagColor;
            }
          }
        }
      };
      if (
        state.lifeCycle.selectedPracticeLibrary &&
        state.lifeCycle.selectedPracticeLibrary._id &&
        state.lifeCycle.selectedPracticeLibrary._id.toString() ===
          payload.packId.toString()
      ) {
        if (!payload.parentActivity) {
          let index = -1;
          for (let [
            i,
            activity,
          ] of state.lifeCycle.selectedPracticeLibrary.activities.entries()) {
            if (activity._id.toString() === payload._id.toString()) {
              index = i;
              break;
            }
          }
          if (index !== -1) {
            state.lifeCycle.selectedPracticeLibrary.activities.splice(index, 1);
          }
        } else {
          let index = -1;
          if (state.lifeCycle.selectedPracticeLibrary.sequenceViewMap) {
            let parentActivity =
              state.lifeCycle.selectedPracticeLibrary.sequenceViewMap.get(
                payload.parentActivity
              );
            for (let [i, activity] of parentActivity.activities.entries()) {
              if (activity._id.toString() === payload._id.toString()) {
                index = i;
                break;
              }
            }
            if (index !== -1) {
              parentActivity.activities.splice(index, 1);
              state.lifeCycle.selectedPracticeLibrary.sequenceViewMap.set(
                payload.parentActivity,
                parentActivity
              );
              if (state.lifeCycle.displaySecondMenu === "Activities") {
                if (payload.isLeafNode) {
                  if (
                    state.lifeCycle.eventBus &&
                    state.lifeCycle.eventBus[
                      parentActivity.parentActivity
                        ? parentActivity.parentActivity
                        : parentActivity._id
                    ]
                  ) {
                    state.lifeCycle.eventBus[
                      parentActivity.parentActivity
                        ? parentActivity.parentActivity
                        : parentActivity._id
                    ].publish({
                      type: "REMOVE_CARD",
                      laneId: parentActivity._id,
                      cardId: payload._id,
                    });
                  }
                } else {
                  let stages = parentActivity.activities.filter((stage) => {
                    return (
                      !stage.isLeafNode &&
                      stage._id.toString !== payload._id.toString()
                    );
                  });
                  let activities = parentActivity.activities.filter((stage) => {
                    return stage.isLeafNode;
                  });
                  stages.forEach((stage) => {
                    stage.title = stage.name;
                    stage.communityTagColor =
                      stage.raci && stage.raci.a
                        ? getColor(
                            stage.raci.a,
                            state.lifeCycle.selectedPracticeLibrary.communities
                          )
                        : "#fff";
                  });
                  activities.forEach((activity) => {
                    activity.title = activity.name;
                    activity.communityTagColor =
                      activity.raci && activity.raci.a
                        ? getColor(
                            activity.raci.a,
                            state.lifeCycle.selectedPracticeLibrary.communities
                          )
                        : "#fff";
                  });
                  let lane = {
                    _id: parentActivity._id,
                    title: "Others",
                    cards: activities,
                    label: 0,
                    communityTagColor:
                      parentActivity.raci && parentActivity.raci.a
                        ? getColor(
                            parentActivity.raci.a,
                            state.lifeCycle.selectedPracticeLibrary.communities
                          )
                        : "#fff",
                    isDummy: true,
                  };
                  if (
                    state.lifeCycle.eventBus &&
                    state.lifeCycle.eventBus[
                      parentActivity.parentActivity
                        ? parentActivity.parentActivity
                        : parentActivity._id
                    ]
                  ) {
                    state.lifeCycle.eventBus[
                      parentActivity.parentActivity
                        ? parentActivity.parentActivity
                        : parentActivity._id
                    ].publish({
                      type: "UPDATE_LANES",
                      lanes: [...stages, lane],
                    });
                  }
                }
              }
            } else {
              if (payload.isLeafNode) {
                if (
                  state.lifeCycle.eventBus &&
                  state.lifeCycle.eventBus[
                    parentActivity.parentActivity
                      ? parentActivity.parentActivity
                      : parentActivity._id
                  ]
                ) {
                  state.lifeCycle.eventBus[
                    parentActivity.parentActivity
                      ? parentActivity.parentActivity
                      : parentActivity._id
                  ].publish({
                    type: "REMOVE_CARD",
                    laneId: parentActivity._id,
                    cardId: payload._id,
                  });
                }
              }
            }
          }
        }
        let pack = state.lifeCycle.selectedPracticeLibrary;
        for (let deletedActivity of payload.deletedActivities) {
          if (pack.communities) {
            for (let i = 0; i < pack.communities.length; i++) {
              for (let j = 0; j < pack.communities[i].communities.length; j++) {
                if (
                  pack.communities[i].communities[j]._id &&
                  deletedActivity.raciData.r.indexOf(
                    pack.communities[i].communities[j]._id.toString()
                  ) != -1
                ) {
                  let index = -1;
                  for (
                    let k = 0;
                    k < pack.communities[i].communities[j].activities.length;
                    k++
                  ) {
                    if (
                      pack.communities[i].communities[j].activities[k]._id &&
                      deletedActivity.activityId &&
                      pack.communities[i].communities[j].activities[
                        k
                      ]._id.toString() === deletedActivity.activityId.toString()
                    ) {
                      index = k;
                      break;
                    }
                  }
                  if (index !== -1) {
                    pack.communities[i].communities[j].activities.splice(
                      index,
                      1
                    );
                  }
                }
                if (
                  state.createPack.selectedPracticeFlowCommunity &&
                  state.createPack.selectedPracticeFlowCommunity._id
                ) {
                  if (
                    state.createPack.selectedPracticeFlowCommunity &&
                    state.createPack.selectedPracticeFlowCommunity._id &&
                    deletedActivity.raciData.r.indexOf(
                      state.createPack.selectedPracticeFlowCommunity._id.toString()
                    ) !== -1
                  ) {
                    if (
                      state.createPack.selectedPracticeFlowCommunity.raci.r.indexOf(
                        deletedActivity.activityId
                      ) !== -1
                    ) {
                      state.createPack.selectedPracticeFlowCommunity.raci.r.splice(
                        state.createPack.selectedPracticeFlowCommunity.raci.r.indexOf(
                          deletedActivity.activityId
                        ),
                        1
                      );
                    }
                  }
                  if (
                    state.createPack.selectedPracticeFlowCommunity &&
                    state.createPack.selectedPracticeFlowCommunity._id &&
                    deletedActivity.raciData.a.indexOf(
                      state.createPack.selectedPracticeFlowCommunity._id.toString()
                    ) !== -1
                  ) {
                    if (
                      state.createPack.selectedPracticeFlowCommunity.raci.a.indexOf(
                        deletedActivity.activityId
                      ) !== -1
                    ) {
                      state.createPack.selectedPracticeFlowCommunity.raci.a.splice(
                        state.createPack.selectedPracticeFlowCommunity.raci.a.indexOf(
                          deletedActivity.activityId
                        ),
                        1
                      );
                    }
                  }
                  if (
                    state.createPack.selectedPracticeFlowCommunity &&
                    state.createPack.selectedPracticeFlowCommunity._id &&
                    deletedActivity.raciData.i.indexOf(
                      state.createPack.selectedPracticeFlowCommunity._id.toString()
                    ) !== -1
                  ) {
                    if (
                      state.createPack.selectedPracticeFlowCommunity.raci.i.indexOf(
                        deletedActivity.activityId
                      ) !== -1
                    ) {
                      state.createPack.selectedPracticeFlowCommunity.raci.i.splice(
                        state.createPack.selectedPracticeFlowCommunity.raci.i.indexOf(
                          deletedActivity.activityId
                        ),
                        1
                      );
                    }
                  }
                  if (
                    state.createPack.selectedPracticeFlowCommunity &&
                    state.createPack.selectedPracticeFlowCommunity._id &&
                    deletedActivity.raciData.c.indexOf(
                      state.createPack.selectedPracticeFlowCommunity._id.toString()
                    ) !== -1
                  ) {
                    if (
                      state.createPack.selectedPracticeFlowCommunity.raci.c.indexOf(
                        deletedActivity.activityId
                      ) !== -1
                    ) {
                      state.createPack.selectedPracticeFlowCommunity.raci.c.splice(
                        state.createPack.selectedPracticeFlowCommunity.raci.c.indexOf(
                          deletedActivity.activityId
                        ),
                        1
                      );
                    }
                  }
                  dispatch.createPack.setSelectedCommunity(
                    state.createPack.selectedPracticeFlowCommunity
                  );
                }
              }
              if (
                state.lifeCycle.eventBus &&
                state.lifeCycle.eventBus[pack.communities[i]._id]
              ) {
                state.lifeCycle.eventBus[pack.communities[i]._id].publish({
                  type: "UPDATE_LANES",
                  lanes: pack.communities[i].communities,
                });
              }
            }
          }
          pack.communitiess = [...pack.communities];
        }

        dispatch.lifeCycle.setSelectedPracticeLibraryData(
          Object.assign({}, state.lifeCycle.selectedPracticeLibrary)
        );
        if (
          state.createPack.selectedPracticeFlowActivity &&
          state.createPack.selectedPracticeFlowActivity._id &&
          state.createPack.selectedPracticeFlowActivity._id.toString() ===
            payload._id.toString()
        ) {
          dispatch.createPack.setSelectedActivityData({});
          dispatch.app.setCollapsedResourcePaneIndexTemp(null);
          dispatch.lifeCycle.showResourecePane(null);
        }
      }
    },
    removeCommunityFromPlaybook(payload, state) {
      let practice = Object.assign({}, state.lifeCycle.selectedPracticeLibrary);
      if (
        practice &&
        practice._id &&
        payload.packId &&
        practice._id.toString() === payload.packId.toString()
      ) {
        if (!payload.parentCommunity) {
          let index;
          for (let [i, community] of practice.communities.entries()) {
            if (
              community._id &&
              community._id.toString() === payload._id.toString()
            ) {
              index = i;
              break;
            }
          }
          practice.communities.splice(index, 1);
        } else if (practice.communities) {
          let index;
          for (let i = 0; i < practice.communities.length; i++) {
            if (
              practice.communities[i] &&
              practice.communities[i]._id &&
              practice.communities[i]._id.toString() ===
                payload.parentCommunity.toString()
            ) {
              for (let [j, community] of practice.communities[
                i
              ].communities.entries()) {
                if (
                  community._id &&
                  community._id.toString() === payload._id.toString()
                ) {
                  index = j;
                  break;
                }
              }
              practice.communities[i].communities.splice(index, 1);
              if (
                state.lifeCycle.communityEventBus &&
                state.lifeCycle.communityEventBus[payload.parentCommunity]
              ) {
                state.lifeCycle.communityEventBus[
                  payload.parentCommunity
                ].publish({
                  type: "UPDATE_LANES",
                  lanes: [...practice.communities[i].communities],
                });
              }
              break;
            }
          }
        }
      }
      dispatch.lifeCycle.setSelectedPracticeLibraryData(
        Object.assign({}, practice)
      );
    },
    changeCommunityPosition(payload, state) {
      let pack = Object.assign({}, state.lifeCycle.selectedPracticeLibrary);
      if (pack.communities) {
        for (let i = 0; i < pack.communities.length; i++) {
          if (
            pack.communities[i] &&
            pack.communities[i]._id.toString() === payload._id.toString()
          ) {
            let communityMap = new Map();
            for (let comm of pack.communities[i].communities) {
              communityMap.set(comm._id, comm);
            }
            pack.communities[i].communities = [];
            payload.communities.forEach((comm) => {
              pack.communities[i].communities.push(communityMap.get(comm));
            });
            pack.communities[i] = Object.assign(pack.communities[i]);
            break;
          }
        }
      }
      dispatch.lifeCycle.setSelectedPracticeLibraryData(pack);
    },
    updateRefInSelectedActivity(payload, state) {
      if (
        state.createPack.selectedPracticeFlowActivity &&
        state.createPack.selectedPracticeFlowActivity.references &&
        state.createPack.selectedPracticeFlowActivity.references.length > 0
      ) {
        for (let reference of state.createPack.selectedPracticeFlowActivity
          .references) {
          if (
            reference &&
            reference.id &&
            reference.id._id &&
            reference.id._id.toString() === payload._id &&
            payload._id.toString()
          ) {
            reference.id = payload;
          }
        }
      }
    },
  },
};
